import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full rounded-lg shadow bg-white" }
const _hoisted_2 = { class: "bg-white border-b border-gray-200" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 sm:p-4" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-4 sm:gap-6" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center text-sm text-[#157813]"
}
const _hoisted_6 = { class: "flex items-center flex-wrap gap-2" }
const _hoisted_7 = { class: "relative flex items-center" }
const _hoisted_8 = {
  for: "unique-toggle",
  class: "relative inline-flex items-center h-6 cursor-pointer"
}
const _hoisted_9 = { class: "relative w-12 h-6" }
const _hoisted_10 = {
  key: 0,
  class: "ml-2 flex h-5 items-center"
}
const _hoisted_11 = { class: "w-full overflow-x-auto" }
const _hoisted_12 = { class: "w-full table-fixed divide-y divide-gray-200" }
const _hoisted_13 = { class: "bg-[#157813]" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center justify-center" }
const _hoisted_16 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_17 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_18 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_19 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "px-2 text-center sm:px-4 py-2 text-xs sm:text-sm text-gray-500 whitespace-nowrap truncate" }
const _hoisted_22 = { class: "px-2 sm:px-4 py-2 text-xs sm:text-sm text-gray-500 whitespace-nowrap truncate" }
const _hoisted_23 = { class: "px-2 sm:px-4 py-2 text-xs sm:text-sm text-gray-500 overflow-hidden" }
const _hoisted_24 = { class: "line-clamp-2 break-all" }
const _hoisted_25 = { class: "px-2 text-center sm:px-4 py-2 text-xs sm:text-sm text-gray-500 whitespace-nowrap truncate" }
const _hoisted_26 = { class: "px-2 sm:px-4 py-2 text-xs sm:text-sm text-gray-500 text-center whitespace-nowrap" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  colspan: "5",
  class: "px-4 py-4 text-center text-sm text-gray-500"
}
const _hoisted_29 = { class: "flex flex-col items-center justify-center py-6" }

import type { Query } from "@/models/Query";
import { onMounted, ref, watch } from 'vue';

interface TableHeader {
  key: string;
  label: string;
  searchable?: boolean;
}

interface Props {
  queries: Query[];
  headers: TableHeader[];
  sortState: {
    key: string;
    direction: "asc" | "desc";
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QueryTable',
  props: {
    queries: {},
    headers: {},
    sortState: {}
  },
  emits: ["sort", "row-click", "toggle-unique"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const showUnique = ref(true);

// Emit toggle event on mount and when toggle changes
onMounted(() => {
  emit('toggle-unique', true);
});

watch(showUnique, (newValue) => {
  emit('toggle-unique', newValue);
});

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (showUnique.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-4 w-4 mr-1.5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1),
                _createElementVNode("span", { class: "font-medium" }, "Filtered", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Show unique queries only", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "sr-only peer",
                    id: "unique-toggle",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showUnique).value = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-unique', showUnique.value)))
                  }, null, 544), [
                    [_vModelCheckbox, showUnique.value]
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-full h-full bg-gray-200 rounded-full peer peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#157813]/30 peer-checked:bg-[#157813] transition-colors duration-200" }, [
                    _createElementVNode("span", { class: "absolute left-1.5 top-1/2 -translate-y-1/2 text-[9px] font-bold text-white opacity-0 peer-checked:opacity-100 transition-all duration-200 select-none" }, "ON"),
                    _createElementVNode("span", { class: "absolute right-1.5 top-1/2 -translate-y-1/2 text-[9px] font-bold text-gray-500 opacity-100 peer-checked:opacity-0 transition-all duration-200 select-none" }, "OFF")
                  ], -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all duration-200 transform peer-checked:translate-x-6 peer-checked:bg-white shadow-sm" }, null, -1))
                ])
              ]),
              (showUnique.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("span", { class: "relative flex h-2 w-2" }, [
                      _createElementVNode("span", { class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-[#157813] opacity-50" }),
                      _createElementVNode("span", { class: "relative inline-flex rounded-full h-2 w-2 bg-[#157813]" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"relative group\" data-v-0dcd3845><button type=\"button\" class=\"flex items-center justify-center h-6 w-6 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#157813]\" data-v-0dcd3845><span class=\"sr-only\" data-v-0dcd3845>Help information</span><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" data-v-0dcd3845><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-0dcd3845></path></svg></button><div class=\"absolute z-10 w-64 p-3 text-xs bg-gray-800 text-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 transform group-hover:translate-y-0 translate-y-1 right-0 top-8\" data-v-0dcd3845><p class=\"font-medium mb-1\" data-v-0dcd3845>Filter Unique Queries</p><p class=\"text-gray-300\" data-v-0dcd3845> When enabled, only the latest unique queries based on text content are displayed</p><div class=\"absolute right-2 top-0 w-2 h-2 bg-gray-800 transform rotate-45 -translate-y-1\" data-v-0dcd3845></div></div></div>", 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", _hoisted_13, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
              return (_openBlock(), _createElementBlock("th", {
                key: header.key,
                onClick: ($event: any) => (_ctx.$emit('sort', header.key)),
                class: _normalizeClass(["px-2 py-3 sm:px-3 text-left text-xs sm:text-sm font-medium text-white uppercase tracking-wider whitespace-nowrap cursor-pointer select-none group transition-colors duration-150 hover:bg-[#126810]", {
                'w-[80px] min-w-[80px]': ['id', 'neuronId', 'extraction', 'queryStartTime'].includes(header.key),
                'w-[120px] min-w-[120px]': header.key === 'author',
                'w-[250px] min-w-[250px] max-w-[400px]': header.key === 'neuronText'
              }])
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(header.label) + " ", 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-block ml-1 transition-opacity duration-150", {'opacity-100': _ctx.sortState.key === header.key, 'opacity-60 group-hover:opacity-100': _ctx.sortState.key !== header.key}])
                  }, [
                    (_ctx.sortState.key === header.key && _ctx.sortState.direction === 'asc')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ]))]))
                      : (_ctx.sortState.key === header.key && _ctx.sortState.direction === 'desc')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                            }, null, -1)
                          ]))]))
                  ], 2)
                ])
              ], 10, _hoisted_14))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queries, (query) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: query.id,
              onClick: ($event: any) => (_ctx.$emit('row-click', query.id)),
              class: "hover:bg-gray-50 text-center cursor-pointer active:bg-gray-100 transition-colors"
            }, [
              _createElementVNode("td", _hoisted_21, _toDisplayString(query.id), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(query.neuronId), 1),
              _createElementVNode("td", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(query.neuronText), 1)
              ]),
              _createElementVNode("td", _hoisted_25, _toDisplayString(query.author), 1),
              _createElementVNode("td", _hoisted_26, _toDisplayString(query.extraction), 1),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "px-2 text-center sm:px-4 py-2 text-xs sm:text-sm text-gray-500 whitespace-nowrap" }, " N/A ", -1))
            ], 8, _hoisted_20))
          }), 128)),
          (_ctx.queries.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                _createElementVNode("td", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "h-10 w-10 text-gray-300 mb-2",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      })
                    ], -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("p", null, "No queries found matching your criteria", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-unique', false))),
                      class: "mt-2 text-[#157813] hover:text-[#126810] text-sm font-medium focus:outline-none focus:underline"
                    }, " Show all queries instead ")
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})